<template>
  <div>
    <div class="flex align-center between b4">
      <b>{{title}}</b>
      <div>
        <i @click="$set(show, 'search', !show.search)" class="fa fa-search" />
        <input
          v-if="show.search"
          class="sm-input l4"
          :placeholder="`Search ${title}`"
          type="search"
          v-model="search"
        />
      </div>
    </div>
    <table class="container p4" style="max-width: 100%">
      <thead style="position: sticky; top: 0">
        <tr class="flex around align-center xs-font b4">
          <th
            @click="
              sortedby[0] !== heading
                ? ($set(sortedby, 0, heading), $set(sortedby, 1, 'asc'))
                : $set(sortedby, 1, sortedby[1] == 'desc' ? 'asc' : 'desc')
            "
            :class="
              data.rows && ((data.rows.length > 0 && !isNaN(+data.rows[0][heading]) ||
                heading == 'icon' ||
                heading == 'image') &&
                'center flexx') ||
              'flexy fill left-text'
            "
            class="p4"
            v-for="heading in data.header"
            :key="heading"
            :style="`order: ${
              ((heading == 'image' || heading == 'icon') && 0) ||
              tableorder.indexOf(heading) ||
              1
            }`"
          >
            <b
              >{{ heading.toUpperCase() }}
              <i
                v-if="sortedby[0] == heading"
                :class="`fa fa-arrow-${sortedby[1] == 'desc' ? 'up' : 'down'}`"
            /></b>
          </th>
        </tr>
      </thead>
      <tbody class="" v-if="data.rows">
        <tr
          class="flex around align-center container"
          v-for="(row, rkey) in data.rows"
          :key="rkey"
        >
          <td
            class="flex align-center p4"
            :class="
              ((!isNaN(+column) || ckey == 'icon' || ckey == 'image') &&
                'center flexx') ||
              'flexy fill'
            "
            :style="`${show[rkey + ckey] ? 'text-align: center;' : ''} order: ${
              ((ckey == 'image' || ckey == 'icon') && 0) ||
              tableorder.indexOf(ckey) ||
              1
            }`"
            v-for="(column, ckey) in row"
            :key="rkey + ckey"
          >
            <div v-if="ckey === 'icon' || ckey === 'image'">
              <img class="thumbnail" :src="column" />
            </div>
            <div v-else>
              <div v-if="typeof column !== 'object' && show">
                {{ column }}
              </div>
              <div
                class="flex justify-start"
                :style="
                  show[rkey + ckey] ? 'width: -webkit-fill-available' : ''
                "
                v-else
              >
                <a
                  class="update-text"
                  @click="$set(show, rkey + ckey, !show[rkey + ckey])"
                  ><i
                    :class="`fa fa-chevron${
                      show[rkey + ckey] ? '-up' : '-down'
                    } `"
                  ></i
                ></a>
                <div
                  :class="show[rkey + ckey] ? 'sub-container' : ''"
                  :style="
                    show[rkey + ckey]
                      ? `position: fixed; z-index: 99; overflow: scroll`
                      : ''
                  "
                  class="l16"
                  v-if="show[rkey + ckey]"
                >
                  <div>
                    <a
                      class="xs-font flex align-center fit center update-text"
                      @click="$set(show, rkey + ckey, !show[rkey + ckey])"
                      ><i class="fa fa-chevron-up"></i>
                      <span class="l16"
                        >{{ Object.keys(tabledata)[rkey] }} / {{ ckey }}</span
                      >
                    </a>
                  </div>
                  <itable :tabledata="column" />
                </div>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
      <tbody v-else>
        <tr
          :style="`border-bottom: 1px dotted ${$store.state.app.style.color}`"
          class="flex around align-center"
        >
          <td
            class="flex align-center flexy center p8"
            v-for="(column, ckey) in data.row"
            :key="ckey"
          >
            <div class="xs-font" v-if="typeof column !== 'object'">
              {{ column }}
            </div>
            <div v-else>
              <a class="xs-font" @click="$set(show, ckey, !show[ckey])"
                ><i class="fa fa-eye fa-2x"></i
              ></a>
              <div
                :class="show[ckey] ? 'container' : ''"
                :style="
                  show[ckey]
                    ? `position: absolute; z-index: 99; overflow: scroll`
                    : ''
                "
                class="l16"
                v-if="show[ckey]"
              >
                <itable :tabledata="column" />
              </div>
            </div>
          </td>
        </tr>
      </tbody>

      <tfoot></tfoot>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    tabledata: { type: [Object, Array] },
    sort: { type: String },
    order: { type: Array },
    title: { type: String },
  },
  computed: {
    tableorder() {
      if (this.order) return this.order;
      else {
        return Array.isArray(this.tabledata)
          ? Object.keys(this.tabledata[0])
          : Object.keys(this.tabledata);
      }
    },
    data() {
      // let sorteddata
      this.$set(this, "isarray", Array.isArray(this.tabledata));
      let objsort = (obj) => Object.fromEntries(Object.entries(obj).sort());
      if (!this.tabledata || this.tabledata.length === 0) {
        return "no data";
      }
      let sorteddata = objsort(this.tabledata);
      if (this.sortedby) {
        sorteddata = this.$_.orderBy(
          this.tabledata,
          [
            (sorted) =>
              !isNaN(+sorted[this.sortedby[0]])
                ? +sorted[this.sortedby[0]]
                : typeof sorted[this.sortedby[0]] == "string"
                ? sorted[this.sortedby[0]].toLowerCase()
                : sorted[this.sortedby[0]],
          ],
          [this.sortedby[1]]
        );
      }
      if (
        typeof this.tabledata == "object" &&
        !Array.isArray(this.tabledata) &&
        Object.entries(this.tabledata).length > 0 &&
        Object.entries(this.tabledata)[0][1] &&
        Object.keys(Object.entries(this.tabledata)[0][1]).toString() ===
          Object.keys(
            Object.entries(this.tabledata)[
              Object.entries(this.tabledata).length - 1
            ][1]
          ).toString()
      ) {
        return {
          header: Object.keys(Object.entries(sorteddata)[0][1]),
          rows: Object.entries(sorteddata).map((x) => x[1]).filter(
          (y) =>
            this.search ?
            JSON.stringify(y).toLowerCase().includes(this.search.toLowerCase()) : true
        ),
        };
      } else if (
        typeof this.tabledata == "object" &&
        !Array.isArray(this.tabledata)
      ) {
        return {
          row: Object.entries(sorteddata).map((x) => x[1]).filter(
          (y) =>
            this.search ?
            JSON.stringify(y).toLowerCase().includes(this.search.toLowerCase()) : true
        ),
          header: Object.keys(sorteddata),
        };
      } else if (
        typeof this.tabledata == "object" &&
        Array.isArray(this.tabledata)
      ) {
        return {
          rows: Object.entries(sorteddata).map((x) => objsort(x[1])).filter(
          (y) =>
            this.search ?
            JSON.stringify(y).toLowerCase().includes(this.search.toLowerCase()) : true
        ),
          header: Object.keys(sorteddata[0]).sort(),
        };
      } else {
        return {};
      }
    },
  },
  data() {
    return {
      isarray: null,
      sortedby: [this.sort, "asc"],
      search: "",
      show: {
        search: false
      }
    };
  },
};
</script>

<style>
table,
tbody,
thead {
  width: 100%;
  overflow-wrap: break-word;
}
tr {
  display: flex;
  width: 100%;
}
th {
  flex: 1;
  padding: 4px;
  overflow-wrap: anywhere;
}
td {
  flex: 1 1 100%;
  width: 40px;
  /* overflow-x: scroll; */
  overflow-wrap: break-word;
  word-wrap: break-word;
}
td > div {
  word-wrap: break-word;
  max-width: 100%;
}
</style>